import { WorkContentMode } from '../enum/EnumRepository';

const pickWorkText = (
  primary: string | null | undefined,
  en: string | null | undefined,
  mode: WorkContentMode,
  engVisible: boolean,
): string => {
  if (mode === WorkContentMode.ENG && engVisible !== false) {
    const trimmed = (en ?? '').trim();
    if (trimmed) return trimmed;
  }
  return primary ?? '';
};

/** 보기 모드에서 ENG가 숨겨지면 원문으로 보이므로 (en) 라벨도 끄기 */
export const isWorkEnglishShown = (
  mode: WorkContentMode,
  engVisible: boolean,
  isEditMode: boolean,
): boolean => mode === WorkContentMode.ENG && (isEditMode || engVisible);

export const resolveWorkTitle = (
  work: { title: string; titleEn: string },
  mode: WorkContentMode,
  engVisible: boolean,
): string => pickWorkText(work.title, work.titleEn, mode, engVisible);

export const resolveWorkMaterial = (
  work: { material: string; materialEn: string },
  mode: WorkContentMode,
  engVisible: boolean,
): string => pickWorkText(work.material, work.materialEn, mode, engVisible);

export const resolveWorkDescription = (
  work: { description: string; descriptionEn: string },
  mode: WorkContentMode,
  engVisible: boolean,
): string => pickWorkText(work.description, work.descriptionEn, mode, engVisible);

export const resolveWorkSizeText = (
  work: { sizeText?: string | null },
): string => work.sizeText ?? '';

export type WorkTextField = 'title' | 'material' | 'description';

type WorkTextFields = {
  title: string;
  titleEn: string;
  material: string;
  materialEn: string;
  description: string;
  descriptionEn: string;
};

/** 편집: 모드별 raw 필드. 조회: engVisible·En 유무에 따라 primary fallback */
export const getWorkTextFieldValue = (
  work: WorkTextFields,
  field: WorkTextField,
  mode: WorkContentMode,
  engVisible: boolean,
  isEditMode: boolean,
): string => {
  if (isEditMode) {
    if (field === 'title') {
      return mode === WorkContentMode.ENG ? work.titleEn : work.title;
    }
    if (field === 'material') {
      return mode === WorkContentMode.ENG ? work.materialEn : work.material;
    }
    return mode === WorkContentMode.ENG ? work.descriptionEn : work.description;
  }
  if (field === 'title') return resolveWorkTitle(work, mode, engVisible);
  if (field === 'material') return resolveWorkMaterial(work, mode, engVisible);
  return resolveWorkDescription(work, mode, engVisible);
};
